import { z } from 'zod';

const sortingOrderSchema = z.union([z.literal('Ascending'), z.literal('Descending')]);

const sortingSchema = z.object({
  key: z.union([
    z.literal('VoucherName'),
    z.literal('Account'),
    z.literal('AccountName'),
    z.literal('Date'),
    z.literal('VoucherText'),
    z.literal('EntryText'),
    z.literal('Amount'),
    z.literal('AbsoluteAmount'),
  ]),
  order: sortingOrderSchema,
});

const sortingOptionsSchema = z.array(sortingSchema);
type SortingOptions = z.infer<typeof sortingOptionsSchema>;

export { sortingOptionsSchema, type SortingOptions };
